import { MACARONS_THEME } from './theme/macarons.project';
import { ChartTheme } from './charts/chart-theme';

export const DEFAULT_ECHART_THEME: ChartTheme = MACARONS_THEME;
